import { StaffRequestInput } from '../../lib/types/models/staff-request/staff-request-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type RequestStaffInput = StaffRequestInput & {
  ids?: number[]
}

export const requestStaffs = (data: RequestStaffInput) => {
  return restApiClient
    .url(constructApiUrl(API.centers.requestStaffs.url, null))
    .post<RequestStaffInput>(data)
}
